
const mutations = {
  setListPendingJobsEmployer: (state, payload) => {
    state.listPendingJobsEmployer = payload
  },
  setListCurrentOfferJobs: (state, payload) => {
    state.listCurrentOfferJobs = payload
  },
  setListOngoingJobsEmployer: (state, payload) => {
    state.listOngoingJobsEmployer = payload
  },
  setListApprovedJobsEmployer: (state, payload) => {
    state.listApprovedJobsEmployer = payload
  },
  setListCompletedJobsEmployer: (state, payload) => {
    state.listCompletedJobsEmployer = payload
  },
  setListSearchJobsEmployer: (state, payload) => {
    state.listSearchJobsEmployer = payload
  },
  setTotalJobsEmployer: (state, payload) => {
    state.totalJobsEmployer = payload
  },
  setListOngoingJobsTalent: (state, payload) => {
    state.listOngoingJobsTalent = payload
  },
  setListPendingJobsTalent: (state, payload) => {
    state.listPendingJobsTalent = payload
  },
  setListCompletedJobsTalent: (state, payload) => {
    state.listCompletedJobsTalent = payload
  },
  setTotalJobsTalent: (state, payload) => {
    state.totalJobsTalent = payload
  },
  setSubmittedJobInfo: (state, payload) => {
    state.submittedJobInfo = payload
  },
  setInvoiceList: (state, payload) => {
    state.invoiceList = payload
  }
}
export default mutations
